import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteFacilityMutationAtom = createMutationAtomFactory(
  'settings.facilityDelete',
  ({ id }: { id: string }) => ({
    coreFacilityDelete: {
      __args: {
        id,
      },
    },
  }),
);
